export default __webpack_public_path__ + "static/img-2-71e0375f5a301ad1644db88cc57ae3ba.jpg";